import {
	ChangeDetectorRef,
	Component,
	ElementRef,
	Inject,
	OnInit,
	Optional,
	QueryList,
	ViewChildren,
} from "@angular/core";
import { DashboardService } from "../../dashboard.service";
import { DashboardPorletsService } from "../../dashboardPorlets.service";
//syncfusion
import { addClass } from "@syncfusion/ej2-base";
import { ColorPickerComponent } from "@syncfusion/ej2-angular-inputs";
import { ColorPickerEventArgs } from "@syncfusion/ej2-inputs";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { PBF_TOKEN } from "../../../service/InjectionToken";
import { DialogService } from "../../../service/dialog.service";
import { getTranslation } from "../../../utils/utils";


@Component({
	selector: "rs-field-format",
	templateUrl: "./field-format.component.html",
	styleUrls: ["./field-format.component.scss"],
})
export class FieldFormatComponent implements OnInit {
	@ViewChildren("colorpicker") colorPicker: QueryList<ColorPickerComponent>;
	@ViewChildren("colorpickerFont")
	colorPickerFont: QueryList<ColorPickerComponent>;
	@ViewChildren("previewColor") PreviewColor: QueryList<ElementRef>;
	@ViewChildren("colorpickerBurden")
	colorpickerBurden: QueryList<ColorPickerComponent>;
	@ViewChildren("colorpickerFontBurden")
	colorpickerFontBurden: QueryList<ColorPickerComponent>;
	@ViewChildren("previewColorBurden")
	previewColorBurden: QueryList<ElementRef>;
	public translation: any = {};
	public alignList: Array<any>;
	public fontSizeList: Array<any>;
	public compareList: Array<any>;
	public stringAndDateCompareList: Array<any>;
	public fontFamilyList: Array<any>;
	public compareSelect: string = "";
	public config: any = {};
	public Conditional: boolean = true;
	public fieldslist = [];
	public currentField;
	public currentFieldFormatInfo;
	private quarterFormat;
	private dateFormat;

	constructor(
		private DashboardService: DashboardService,
		public dashboardPorletsService: DashboardPorletsService,
		private dialogService: DialogService,
		public dialogRef: MatDialogRef<FieldFormatComponent>,
		@Inject(MAT_DIALOG_DATA) public data: any,
		@Optional() @Inject(PBF_TOKEN) private pbf: any,

	) { }

	ngOnInit() {
		this.translation = getTranslation()
		this.alignList = this.setAlignList();
		this.fontSizeList = this.setFontSizeList();
		this.compareList = this.setCompareList();
		this.stringAndDateCompareList = this.setStringAndDateCompareList();
		this.fontFamilyList = this.setFontFamilyList();
		this.quarterFormat = this.setQuarterFormat();
		this.dateFormat = this.setDateFormat();
		if (this.data.portletData) this.getConditionalData();
	}

	// 获取field list页面数据
	private getConditionalData() {
		this.config = JSON.parse(this.data.portletData.config);
		this.fieldslist = [];
		//pivot table/chart(get the rows,colums,values etc)
		if (
			[
				"pivot",
				"bar",
				"column",
				"line",
				"area",
				"pie",
				"radar",
				"newchart",
			].includes(this.config.portletType)
		) {
			if (this.config.xaxis.groups)
				for (let group of this.config.xaxis.groups) {
					this.fieldslist.push(
						this.config.fields.filter(
							(el) => el.colName === group.name
						)[0]
					);
				}
			if (this.config.columnGroup)
				for (let column of this.config.columnGroup) {
					this.fieldslist.push(
						this.config.fields.filter(
							(el) => el.colName === column.name
						)[0]
					);
				}
			if (this.config.yaxis.series)
				for (let value of this.config.yaxis.series) {
					const pvalue = this.config.fields.find(
						(el) => el.colName === value.colName
					);
					let allFields = this.config.fields;
					let displayName = value.title;
					if (allFields && pvalue) {
						const item = allFields.find(
							(field) => field.colName === pvalue.colName
						);
						if (item) {
							displayName =
								(item.format &&
									item.format.length &&
									item.format[0].displayName) ||
								item.langValue;
						}
					}
					if (pvalue) {
						pvalue["isValue"] = true;
						pvalue["showSubTotals"] = value.showSubTotals;
						pvalue["showGrandTotals"] = value.showGrandTotals;
						pvalue["langValue"] = displayName;
						this.fieldslist.push(pvalue);
					} else {
						value.isValue = true;
						this.fieldslist.push({
							colName: value.colName,
							langValue: displayName,
							isValue: true,
							showSubTotals: value.showSubTotals,
							showGrandTotals: value.showGrandTotals,
						});
					}
				}
		} else {
			let keys = [];
			if (this.config.fields.length)
				keys = Object.keys(this.config.fields[0]);
			this.fieldslist = this.config.fields.filter((el) =>
				keys.includes("visible")
					? el.visible && !el.isHidden
					: !el.isHidden
			);
		}
		// 所有field都给一个showGrandTotals和showSubTotals的值，绑定field list页面icon状态，及format页面Hide subtotal、Hide grandtotal等状态
		this.fieldslist.map((el) => {
			let keys = Object.keys(el);
			if (
				!keys.includes("showGrandTotals") ||
				el.showGrandTotals === undefined
			)
				el.showGrandTotals = true;
			if (
				!keys.includes("showSubTotals") ||
				el.showSubTotals === undefined
			)
				el.showSubTotals = true;
		});
	}

	// 打开field的format页面
	public openFormat(item) {
		//clear the checkbox
		this.Conditional = false;
		this.currentField = JSON.parse(JSON.stringify(item));
		this.currentFieldFormatInfo =
			(item.format && item.format[0]) || this.setFormatGroupDefaultData();
		delete this.currentField.format; // 删掉currentField的format，将format信息保存在currentFieldFormatInfo
		this.selectOption(item.colName, "field");
		if (!["string", "nvarchar", "date", "datetime"].includes(item.dataType))
			this.addColorPickerStyle();
		this.currentFieldFormatInfo.formatList &&
			this.currentFieldFormatInfo.formatList.map(
				(el) =>
				(el.isChecked =
					el.key ==
						this.currentFieldFormatInfo.selectedFormatDisplay
						? true
						: false)
			);
	}

	public selectOption(value, type) {
		let PreviewColorElement = this.PreviewColor["_results"];
		let previewColorBurdenElement = this.previewColorBurden["_results"];
		let allFields = this.config.fields;
		let displayName = this.currentField.displayName;
		if (allFields && (!displayName || displayName.length === 0)) {
			const item = allFields.find(
				(field) => field.colName === this.currentField.colName
			);
			if (item) {
				displayName =
					(item.format &&
						item.format.length &&
						item.format[0].displayName) ||
					item.langValue;
			}
		}
		switch (type) {
			case "field":
				this.currentFieldFormatInfo.selectedField =
					this.currentField.colName;
				this.currentFieldFormatInfo.dataType =
					this.currentField.dataType;
				this.currentFieldFormatInfo.displayName = displayName || "";
				this.getFiledFormat();
				break;
			case "compare":
				this.currentFieldFormatInfo.formatChecked = true;
				this.currentFieldFormatInfo.compareSelect = this.optionFilter(
					this.compareList,
					"code",
					value
				)[0].code;
				break;
			case "selectdDateType":
				this.currentFieldFormatInfo.formatChecked = true;
				if (value == "Quarter") {
					this.currentFieldFormatInfo.formatList = this.quarterFormat;
				} else if (value == "Date") {
					this.currentFieldFormatInfo.formatList = this.dateFormat;
				}
				this.currentFieldFormatInfo.selectedFormatDisplay = "";
				this.currentFieldFormatInfo.selectedFormat = "";
				break;
			case "selectdDateformat":
			case "number":
				this.currentFieldFormatInfo.formatChecked = true;
				for (const iterator of this.currentFieldFormatInfo.formatList) {
					iterator.isChecked = Boolean(iterator.key == value);
					if (iterator.key == value)
						this.currentFieldFormatInfo.selectedFormat =
							iterator.val;
				}
				break;
			case "fontFamily":
				this.currentFieldFormatInfo.fontSettingChecked = true;
				this.currentFieldFormatInfo.fontFamilyValue = this.optionFilter(
					this.fontFamilyList,
					"value",
					value
				)[0].value;
				(
					PreviewColorElement[0].nativeElement.querySelector(
						".format-groups"
					) as HTMLElement
				).style.fontFamily =
					this.currentFieldFormatInfo.fontFamilyValue;
				break;
			case "negaFontFamily":
				this.currentFieldFormatInfo.fontSettingChecked = true;
				this.currentFieldFormatInfo.negaFontFamilyValue =
					this.optionFilter(
						this.fontFamilyList,
						"value",
						value
					)[0].value;
				(
					previewColorBurdenElement[0].nativeElement.querySelector(
						".format-groups"
					) as HTMLElement
				).style.fontFamily =
					this.currentFieldFormatInfo.negaFontFamilyValue;
				break;
			case "negaFontSize":
				this.currentFieldFormatInfo.fontSettingChecked = true;
				this.currentFieldFormatInfo.negaFontSizeValue =
					this.optionFilter(
						this.fontSizeList,
						"value",
						value
					)[0].value;
				(
					previewColorBurdenElement[0].nativeElement.querySelector(
						".format-groups"
					) as HTMLElement
				).style.fontSize =
					this.currentFieldFormatInfo.negaFontSizeValue;
				break;
			case "fontSize":
				this.currentFieldFormatInfo.fontSettingChecked = true;
				this.currentFieldFormatInfo.fontSizeValue = this.optionFilter(
					this.fontSizeList,
					"value",
					value
				)[0].value;
				(
					PreviewColorElement[0].nativeElement.querySelector(
						".format-groups"
					) as HTMLElement
				).style.fontSize = this.currentFieldFormatInfo.fontSizeValue;
				break;
			default:
				break;
		}
	}

	private getFiledFormat() {
		if (!this.currentFieldFormatInfo.align)
			this.currentFieldFormatInfo.align = [
				"string",
				"nvarchar",
				"date",
				"datetime",
			].includes(this.currentField.dataType)
				? "Left"
				: "Right";
		switch (this.currentField.dataType) {
			case "number":
				this.currentFieldFormatInfo.formatList =
					this.dashboardPorletsService.GetFigureFormat();
				this.addColorPickerStyle();
				break;
			case "integer":
				this.currentFieldFormatInfo.formatList =
					this.dashboardPorletsService.GetFigureFormat3();
				this.addColorPickerStyle();
				break;
			case "percent":
			case "percentNum":
				this.currentFieldFormatInfo.formatList =
					this.dashboardPorletsService.GetPercentFormats();
				break;
			case "multiple":
				this.currentFieldFormatInfo.formatList =
					this.dashboardPorletsService.GetMultipleFormats();
				break;
			default:
				break;
		}
	}

	private optionFilter(data, field, compareValue) {
		return data.filter((item) => item[field] === compareValue);
	}

	public changeAligh(code) {
		this.currentFieldFormatInfo.align = code;
		this.currentFieldFormatInfo.formatChecked = true;
	}

	private addColorPickerStyle() {
		setTimeout(() => {
			let colorPickerFontElement = this.colorPickerFont["_results"];
			let colorPickerElement = this.colorPicker["_results"];
			let PreviewColorElement = this.PreviewColor["_results"];
			let colorpickerBurdenElement = this.colorpickerBurden["_results"];
			let colorpickerFontBurdenElement =
				this.colorpickerFontBurden["_results"];
			let previewColorBurdenElement = this.previewColorBurden["_results"];
			colorPickerFontElement.forEach((item) => {
				addClass(
					[
						item.element.nextElementSibling.querySelector(
							".e-selected-color"
						),
					],
					"e-icons"
				);
			});
			colorPickerElement.forEach((item) => {
				addClass(
					[
						item.element.nextElementSibling.querySelector(
							".e-selected-color"
						),
					],
					"e-icons"
				);
			});

			if (colorpickerBurdenElement.length)
				colorpickerBurdenElement.forEach((item) => {
					addClass(
						[
							item.element.nextElementSibling.querySelector(
								".e-selected-color"
							),
						],
						"e-icons"
					);
				});
			if (colorpickerFontBurdenElement.length)
				colorpickerFontBurdenElement.forEach((item) => {
					addClass(
						[
							item.element.nextElementSibling.querySelector(
								".e-selected-color"
							),
						],
						"e-icons"
					);
				});
			addClass(
				[
					colorPickerFontElement[0].element.nextElementSibling.querySelector(
						".e-selected-color"
					),
				],
				"format-groups"
			);
			addClass(
				[
					colorPickerElement[0].element.nextElementSibling.querySelector(
						".e-selected-color"
					),
				],
				"format-groups"
			);
			addClass(
				[
					PreviewColorElement[0].nativeElement.querySelector(
						".preview"
					),
				],
				"format-groups"
			);

			(
				PreviewColorElement[0].nativeElement.querySelector(
					".format-groups"
				) as HTMLElement
			).style.color = this.currentFieldFormatInfo.fontColor;
			(
				PreviewColorElement[0].nativeElement.querySelector(
					".format-groups"
				) as HTMLElement
			).style["background-color"] =
				this.currentFieldFormatInfo.backgroundColor;
			(
				colorPickerFontElement[0].element.nextElementSibling.querySelector(
					".format-groups"
				) as HTMLElement
			).style.borderBottomColor = this.currentFieldFormatInfo.fontColor;
			(
				colorPickerElement[0].element.nextElementSibling.querySelector(
					".format-groups"
				) as HTMLElement
			).style.borderBottomColor =
				this.currentFieldFormatInfo.backgroundColor;

			if (
				colorpickerBurdenElement[0] &&
				colorpickerFontBurdenElement[0] &&
				previewColorBurdenElement[0]
			) {
				addClass(
					[
						colorpickerFontBurdenElement[0].element.nextElementSibling.querySelector(
							".e-selected-color"
						),
					],
					"format-groups"
				);
				addClass(
					[
						colorpickerBurdenElement[0].element.nextElementSibling.querySelector(
							".e-selected-color"
						),
					],
					"format-groups"
				);
				addClass(
					[
						previewColorBurdenElement[0].nativeElement.querySelector(
							".preview"
						),
					],
					"format-groups"
				);

				(
					previewColorBurdenElement[0].nativeElement.querySelector(
						".format-groups"
					) as HTMLElement
				).style.color = this.currentFieldFormatInfo.negaFontColor;
				(
					previewColorBurdenElement[0].nativeElement.querySelector(
						".format-groups"
					) as HTMLElement
				).style["background-color"] =
					this.currentFieldFormatInfo.negaBackgroundColor;
				(
					colorpickerFontBurdenElement[0].element.nextElementSibling.querySelector(
						".format-groups"
					) as HTMLElement
				).style.borderBottomColor =
					this.currentFieldFormatInfo.negaFontColor;
				(
					colorpickerBurdenElement[0].element.nextElementSibling.querySelector(
						".format-groups"
					) as HTMLElement
				).style.borderBottomColor =
					this.currentFieldFormatInfo.negaBackgroundColor;
			}
		}, 400);
	}

	public colorOnChange(args: ColorPickerEventArgs, type?): void {
		this.currentFieldFormatInfo.fontSettingChecked = true;
		let colorPickerFontElement = this.colorPickerFont["_results"];
		let colorPickerElement = this.colorPicker["_results"];
		let PreviewColorElement = this.PreviewColor["_results"];
		let colorpickerBurdenElement = this.colorpickerBurden["_results"];
		let colorpickerFontBurdenElement =
			this.colorpickerFontBurden["_results"];
		let previewColorBurdenElement = this.previewColorBurden["_results"];
		if (type) {
			switch (type) {
				case "font":
					(
						colorPickerFontElement[0].element.nextElementSibling.querySelector(
							".format-groups"
						) as HTMLElement
					).style.borderBottomColor = args.currentValue.rgba;
					(
						PreviewColorElement[0].nativeElement.querySelector(
							".format-groups"
						) as HTMLElement
					).style.color = args.currentValue.rgba;
					this.currentFieldFormatInfo.fontColor =
						args.currentValue.rgba;
					break;
				case "ngeaFont":
					(
						colorpickerFontBurdenElement[0].element.nextElementSibling.querySelector(
							".format-groups"
						) as HTMLElement
					).style.borderBottomColor = args.currentValue.rgba;
					(
						previewColorBurdenElement[0].nativeElement.querySelector(
							".format-groups"
						) as HTMLElement
					).style.color = args.currentValue.rgba;
					this.currentFieldFormatInfo.negaFontColor =
						args.currentValue.rgba;
					break;
				case "ngeaBgColor":
					(
						colorpickerBurdenElement[0].element.nextElementSibling.querySelector(
							".format-groups"
						) as HTMLElement
					).style.borderBottomColor = args.currentValue.rgba;
					(
						previewColorBurdenElement[0].nativeElement.querySelector(
							".format-groups"
						) as HTMLElement
					).style["background-color"] = args.currentValue.rgba;
					this.currentFieldFormatInfo.negaBackgroundColor =
						args.currentValue.rgba;
					break;
				default:
					break;
			}
		} else {
			(
				colorPickerElement[0].element.nextElementSibling.querySelector(
					".format-groups"
				) as HTMLElement
			).style.borderBottomColor = args.currentValue.rgba;
			(
				PreviewColorElement[0].nativeElement.querySelector(
					".format-groups"
				) as HTMLElement
			).style["background-color"] = args.currentValue.rgba;
			this.currentFieldFormatInfo.backgroundColor =
				args.currentValue.rgba;
		}
	}

	public changeHideStatus(code) {
		this.currentField[code] = !this.currentField[code];
	}

	public saveFormat() {
		this.config.yaxis.series.forEach((col) => {
			if (
				col.colName === this.currentField.colName &&
				!this.config.fields.find(
					(item) => item.colName === this.currentField.colName
				)
			) {
				this.config.fields.push({
					colName: this.currentField.colName,
					dataType: "number",
					displayName: this.currentField.langValue,
					dp: 2,
					format: [],
					formula: null,
					isCalculatedField: true,
					isGroup: false,
					isHidden: false,
					isValue: true,
					langCode: this.currentField.colName,
					langValue: this.currentField.colName,
					seq: this.config.fields.length + 1,
					showGrandTotals: this.currentField.showGrandTotals,
					showSubTotals: this.currentField.showSubTotals,
					sortColumn: null,
					visible: true,
				});
			}
		});

		for (const field of this.config.fields) {
			if (this.currentField.colName === field.colName) {
				field.showGrandTotals = this.currentField.showGrandTotals;
				field.showSubTotals = this.currentField.showSubTotals;
				if (
					this.currentFieldFormatInfo.formatChecked ||
					this.currentFieldFormatInfo.fontSettingChecked
				) {
					field.format = [];
					field.displayName = this.currentFieldFormatInfo.displayName;
					field.format.push(this.currentFieldFormatInfo);
				} else delete field.format;
			}
		}

		for (const series of this.config.yaxis.series) {
			if (this.currentFieldFormatInfo.selectedField === series.colName) {
				series.showSubTotals = this.currentField.showSubTotals;
				series.showGrandTotals = this.currentField.showGrandTotals;
				let fields = this.config.fields.filter(
					(el) =>
						el.colName === this.currentFieldFormatInfo.selectedField
				);
				if (fields && fields.length) {
					if (
						fields[0].format &&
						fields[0].format.length &&
						fields[0].format[0].formatChecked
					)
						series.title =
							this.currentFieldFormatInfo.displayName ||
							fields[0].langValue.replace("Calculate", "").trim();
				} else if (series.calMethod !== "CalculatedField")
					series.title = series.colName;
			}
		}
		this.data.portletData.config = JSON.stringify(this.config);
		const index = this.data.portlets.findIndex(
			(x) => x.newId === this.data.portletData.newId
		);
		if (index > -1)
			this.data.portlets[index].config = this.data.portletData.config;
		this.DashboardService.tableFormat.next(this.data.portletData.newId);
		this.dialogRef.close();
	}

	public close() {
		this.dialogRef.close();
	}

	public clearFormat_All() {
		const _title =
			this.translation
				.ARE_YOU_SURE_TO_CLEAR_ALL_THE_FORMATTING_AND_SUB_TOTALS_TO_DEFAULT_SETTINGS ||
			"Are you sure to clear all the formatting and totals to default settings?";
		const _no = this.translation.NO_PLEASE_GO_BACK || "No, please go back";
		const _yes = this.translation.YES_CLEAR_THEM || "Yes, clear them";
		// const dialogRef = this.layoutUtilsService.alertElement(
		// 	this.translation.WARNING || ".WARNING",
		// 	_title,
		// 	_no,
		// 	_yes,
		// 	true,
		// 	true,
		// 	"450px",
		// 	"320px"
		// );
		const dialogRef = this.dialogService.showCommonDilaog({
			title: this.translation.WARNING || ".WARNING",
			description: _title,
			saveBtnLabel: _yes,
			cancelBtnLabel: _no,
		});
		dialogRef.afterClosed().subscribe((res) => {
			if (res === "save") {
				this.config.fields.map((el) => {
					delete el.format;
					delete el.showSubTotals;
					delete el.showGrandTotals;
				});
				//SMP2-3010
				//pivot
				if (this.config.portletType === "pivot") {
					if (this.config.yaxis.series) {
						this.config.yaxis.series.map((el) => {
							delete el.showSubTotals;
							delete el.showGrandTotals;
						});
					}
				}
				this.data.portletData.config = JSON.stringify(this.config);
				const index = this.data.portlets.findIndex(
					(x) => x.newId === this.data.portletData.newId
				);
				if (index > -1)
					this.data.portlets[index].config = this.data.portletData.config;
				this.DashboardService.tableFormat.next(this.data.portletData.newId);
				this.dialogRef.close();
			}
		});
	}

	public clearFormat_Current() {
		this.currentFieldFormatInfo = this.setFormatGroupDefaultData();
		this.currentField.showSubTotals = true;
		this.currentField.showGrandTotals = true;
		if (
			!["string", "nvarchar", "date", "datetime"].includes(
				this.currentFieldFormatInfo.dataType
			)
		)
			this.addColorPickerStyle();
	}

	public disabledGrandTotal() {
		if (
			this.config.portletType !== "pivot" &&
			this.config.portletType !== "table"
		) {
			return true;
		} else {
			if (this.config.portletType === "table") {
				if (
					this.currentField.dataType !== "string" &&
					this.currentField.dataType !== "datetime" &&
					this.currentField.dataType !== "date"
				)
					return false;
				else return true;
			} else {
				if (this.currentField.isValue) return false;
				else return true;
			}
		}
	}

	private setAlignList() {
		return [
			{
				name: "format_align_left",
				code: "Left",
			},
			{
				name: "format_align_center",
				code: "Center",
			},
			{
				name: "format_align_right",
				code: "Right",
			},
		];
	}

	private setFontSizeList() {
		return [
			{
				value: "12px",
			},
			{
				value: "13px",
			},
			{
				value: "14px",
			},
			{
				value: "15px",
			},
			{
				value: "16px",
			},
			{
				value: "17px",
			},
			{
				value: "18px",
			},
			{
				value: "19px",
			},
			{
				value: "20px",
			},
		];
	}

	private setCompareList() {
		return [
			{
				value: this.translation.LESS_THAN || "Less Than",
				code: "LessThan",
			},
			{
				value:
					this.translation.LESS_THAN_OR_EQUAL_TO ||
					"Less Than Or Equal To",
				code: "LessThanOrEqualTo",
			},
			{
				value: this.translation.GREATER_THAN || "Greater Than",
				code: "GreaterThan",
			},
			{
				value:
					this.translation.GREATER_THAN_OR_EQUAL_TO ||
					"Greater Than Or Equal To",
				code: "GreaterThanOrEqualTo",
			},
			{
				value: this.translation.EQUALS || "Equals",
				code: "Equals",
			},
			{
				value: this.translation.NOT_EQUALS || "Not Equals",
				code: "NotEquals",
			},
			{
				value: this.translation.BETWEEN || "Between",
				code: "Between",
			},
			{
				value: this.translation.NOT_BETWEEN || "Not Between",
				code: "NotBetween",
			},
		];
	}

	private setStringAndDateCompareList() {
		return [
			{
				value: "Equals",
				code: "Equals",
			},
			{
				value: "Not Equals",
				code: "NotEquals",
			},
		];
	}

	private setFontFamilyList() {
		return [
			{
				value: "Arial",
			},
			{
				value: "San Serif",
			},
			{
				value: "Impact",
			},
			{
				value: "Trebuchet MS",
			},
			{
				value: "Serif",
			},
			{
				value: "Verdana",
			},
			{
				value: "Courier New",
			},
			{
				value: "Times New Roman",
			},
			{
				value: "Tahoma",
			},
			{
				value: "Gerogia",
			},
		];
	}

	private setFormatGroupDefaultData() {
		return {
			selectedField: this.currentField.colName,
			dataType: this.currentField.dataType,
			compareSelect: "",
			compareValue1: null,
			compareValue2: null,
			align: "",
			selectedFormat: "",
			selectedFormatDisplay: "",
			fontFamilyValue: "San Serif",
			negaFontFamilyValue: "San Serif",
			negaFontSizeValue: "12px",
			negaFontColor: "#495057",
			negaBackgroundColor: "#F8E71C",
			fontSizeValue: "12px",
			fontColor: "#495057",
			backgroundColor: "#F8E71C",
			displayName: "",
			formatList: [],
			fontSettingChecked: false,
			formatChecked: false,
			dateType: "",
		};
	}

	private setQuarterFormat() {
		return [
			{ key: "03/2021", val: 1, isChecked: false },
			{ key: "03/21", val: 2, isChecked: false },
			{ key: "3/2021", val: 3, isChecked: false },
			{ key: "3/21", val: 4, isChecked: false },
			{ key: "March 2021", val: 5, isChecked: false },
			{ key: "Mar, 2021", val: 6, isChecked: false },
			{ key: "March, 2021", val: 7, isChecked: false },
			{ key: "Q1 2021", val: 8, isChecked: false },
			{ key: "Q1 21", val: 9, isChecked: false },
			{ key: "2021 Q1", val: 10, isChecked: false },
			{ key: "21 Q1", val: 11, isChecked: false },
			{ key: "2021", val: 12, isChecked: false },
		];
	}

	private setDateFormat() {
		return [
			{ key: "14/03/2021 (DD/MM/YYYY)", val: 1, isChecked: false },
			{ key: "14/03/21 (DD/MM/YY)", val: 2, isChecked: false },
			{ key: "03/14/2021 (MM/DD/YYYY)", val: 3, isChecked: false },
			{ key: "03/14/21 (MM/DD/YY)", val: 4, isChecked: false },
			{ key: "2021-03-14 (YYYY-MM-DD)", val: 5, isChecked: false },
			{ key: "21-03-14 (YY-MM-DD)", val: 6, isChecked: false },
			{ key: "14-03-2021 (DD-MM-YYYY)", val: 7, isChecked: false },
			{ key: "14-03-21 (DD-MM-YY)", val: 8, isChecked: false },
			{ key: "03-14-2021 (MM-DD-YYYY)", val: 9, isChecked: false },
			{ key: "03-14-21 (MM-DD-YY)", val: 10, isChecked: false },
			{ key: "Mar 14, 2021 (MMM DD, YYYY)", val: 11, isChecked: false },
			{ key: "14-Mar-2021 (DD-MMM-YYYY)", val: 12, isChecked: false },
		];
	}
}
